import { createSlice } from '@reduxjs/toolkit';

export interface ProjectTeam {
  developer: string;
  technicalAssistance: string;
  cclfRepresentative: string;
  cdhRepresentative: string;
  architect: string;
  civilEngineer: string;
  structuralEngineer: string;
  generalContractor: string;
}

const initialState: ProjectTeam = {
  developer: '',
  technicalAssistance: '',
  cclfRepresentative: '',
  cdhRepresentative: '',
  architect: '',
  civilEngineer: '',
  structuralEngineer: '',
  generalContractor: '',
};

export const ProjectTeamSlice = createSlice({
  name: 'projectTeamInfo',
  initialState,
  reducers: {
    set(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { set } = ProjectTeamSlice.actions;

export default ProjectTeamSlice.reducer;
